import { render, staticRenderFns } from "./UserPane.vue?vue&type=template&id=e663dde2&scoped=true&"
import script from "./UserPane.vue?vue&type=script&lang=js&"
export * from "./UserPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e663dde2",
  null
  
)

export default component.exports